if (!customElements.get("new-arrivals-card")) {
    class NewArrivalsCard extends HTMLElement {
        constructor() {
            super();
            this.variantsInfo = JSON.parse(this.getAttribute('variants-info'));
            this.addToCardButton = this.querySelector(this.getAttribute('button-selector'))
            this.selectSelector = this.getAttribute('select-selector');
            this.originPriceDom = this.querySelector(this.getAttribute('origin-price-selector'))
            this.finalPriceDom = this.querySelector(this.getAttribute('final-price-selector'))
            this.calcDiscount = this.getAttribute('calc_discount') && !isNaN(Number(this.getAttribute('calc_discount'))) ? Number(this.getAttribute('calc_discount')) : null
        }

        connectedCallback() {
            this.initSelectChangeListeners()
            this.setVariantId()
        }

        initSelectChangeListeners() {
            this.querySelectorAll(this.selectSelector).forEach((ele) => {
                ele.addEventListener('change', this.setVariantId.bind(this));
            });
        }

        setVariantId() {
            const selects = this.querySelectorAll(this.selectSelector);
            const selectedInfo = [];
            selects.forEach((select) => {
                const optionName = select.name;
                const value = select.selectedOptions[0].value;
                selectedInfo.push({ key: optionName, value });
            });

            const matchedVariant = this.variantsInfo.find((variant) => {
                return selectedInfo.every((sel) => variant.options[sel.key] === sel.value);
            });

            if (matchedVariant) {
                this.selectedVariantId = matchedVariant.id;
                this.isAvailable = matchedVariant.available
                this.setPrice(matchedVariant)
            } else {
                this.selectedVariantId = null;
            }

            if (this.addToCardButton) {
                const isDisabled = !(this.selectedVariantId && this.isAvailable)
                const innerText = isDisabled ? 'Sold Out' : 'Add To Cart'
                this.addToCardButton.setDisabled(isDisabled, innerText)
                this.addToCardButton.dataset.variantId = this.selectedVariantId
            }
        }

        setPrice(matchedVariant) {
            const format = window.theme?.settings?.money_with_currency_format || '${{amount}}'
            const formatMoney = (v) => window.formatMoney(v, format)

            const basePrice = matchedVariant.price
            const finalPrice = this.calcDiscount
                ? basePrice * (1 - this.calcDiscount)
                : basePrice

            if (this.finalPriceDom) {
                this.finalPriceDom.innerText = formatMoney(finalPrice)
            }

            if (this.calcDiscount && this.originPriceDom) {
                this.originPriceDom.innerText = formatMoney(basePrice)
            }
        }

    }
    customElements.define("new-arrivals-card", NewArrivalsCard);
}